$(document).foundation();
var workplaceId;
$(document).ready(function() {
	
	if($('.cookie-consent-overlay').length) {
		$('.cookie-consent-overlay').show();
	}
	
	setExcerptHeights();
		
	// hide site messages after 5s
	setTimeout(function() {
		setHeaderTrigger($('header').outerHeight()-$(".messages").outerHeight(true));
		$(".messages").slideUp("normal", function() { 
			$(this).remove(); 
		});
	}, 5000);
	
	workplaceId = $('body').data('workplace-id');
	
	
	// recaptcha submit handler
	$('.recaptcha-form input[type="submit"]').click(function(e) {
		var $button = $(e.currentTarget);
		var $form = $button.closest('form');
		e.preventDefault();
		if($form[0].reportValidity()) {
			grecaptcha.enterprise.ready(function() {
				grecaptcha.enterprise.execute(gRecaptchaPublicKey, {action: $form.data('recaptcha-action')}).then(function(token) {
					if (!$form.find('.recaptcha-token').length) {
						$form.append('<input type="hidden" name="recaptchaToken" class="recaptcha-token">');
					}
					if (!$form.find('.recaptcha-submit-elem').length) {
						$form.append('<input type="hidden" class="recaptcha-submit-elem">');
					}
					$form.find('.recaptcha-token').val(token);
					$form.find('.recaptcha-submit-elem').val($button.val()).attr('name',$button.attr('name'));
					$form.unbind().submit(); 
				});
			});
		}
	});
	
	
	$('html').click(function() {
		$('#expanding-nav').hide();
	})
	
	$('#expanding-nav, .expanding-nav-toggle').on('click', function(e) {
		e.stopPropagation();
	})
	
	$('.expanding-nav-toggle').on('click', function() {
		$('#expanding-nav').toggle();
	})
	
	$('#areaOfBusiness').on('change', function(e) {
		if (e.currentTarget.value == 125) {
			showFieldHolder('businessAreaOther', true);
		} else {
			hideFieldHolder('businessAreaOther');
		}
	});
	
	$('input[name="employmentStatus"]').on('change', function(e) {
		if (e.currentTarget.value == 'employee' || e.currentTarget.value == 'consultant') {
			showFieldHolder('jobTitle', true);
		} else {
			hideFieldHolder('jobTitle');
		}
		if (e.currentTarget.value == 'consultant') {
			$('#jobTitle').prev('.field-label').html('<span class="mandatory">*</span>Company Name');
		} else if (e.currentTarget.value == 'employee') {
			$('#jobTitle').prev('.field-label').html('<span class="mandatory">*</span>Job Title');
		}
	});
	
	$('#selectWorkplace').on('change', function(e) {
		$('#selectWorkplaceForm').submit();
	})
	
	$('input[name="whsRep"]').on('change', function(e) {
		console.log(e.currentTarget.value);
		if (e.currentTarget.value === '1') {
			showFieldHolder('whsRepName', true);
		} else {
			hideFieldHolder('whsRepName');
		}
	})
	// force currency fields to 2 decimal places
	$('.currency-accuracy').val(function(i,v) {
		return parseFloat(v).toFixed(2);
	});
	$(document).on('change','.currency-accuracy', function() {
		if ($(this).val()) {
			$(this).val(parseFloat($(this).val()).toFixed(2));    
		}
	});
	
	// clear validation error when inputs are updated
	$(document).on('keyup','.validation-failed .field-input', function(e) {
		$(e.currentTarget).closest('.validation-failed').removeClass('validation-failed').find('.label.alert').remove();
	});
	
	// enforce start and end dates for linked date inputs
	$('.flatpickr[data-end-date-elem]').each(function() {
		var $this = $(this);
		var endDateElemIdAttr = $this.data('end-date-elem');
		$('#'+endDateElemIdAttr)[0]._flatpickr.config.onChange.push(function(selectedDates, dateStr) {
			$this[0]._flatpickr.set("maxDate",new Date(selectedDates[0].getTime() - 1 * 86400000 ));	
		});
	});
	$('.flatpickr[data-start-date-elem]').each(function() {
		var $this = $(this);
		var startDateElemIdAttr = $this.data('start-date-elem');
		$('#'+startDateElemIdAttr)[0]._flatpickr.config.onChange.push(function(selectedDates, dateStr) {
			$this[0]._flatpickr.set("minDate",new Date(selectedDates[0].getTime() + 1 * 86400000 ));	
		});
	});
	
	$(document).on('click', '.delete-risk-assessment', function(e) { 
		
		var $elem = $(e.currentTarget);
		var table = $('#table_risk-assessment').dataTable();
		if (confirm("Are you sure you want to delete this risk assessment?")) {
			$.ajax({
				url: "/ajax/accreditation/uv-risk-assessment/delete",
				type : "POST",
				contentType : 'application/json',
				data : JSON.stringify({r: $elem.data('risk-assessment-id'), token: $elem.data('token')})
			}).done(function() {
				table.fnDraw(true);
			}).fail(function() {
				alert("Sorry, the risk assessment could not be deleted.")
			});			
		}
	});
	
	$(document).on('click', '.delete-sun-protection-policy', function(e) { 
		
		var $elem = $(e.currentTarget);
		var table = $('#table_sun-protection-policy').dataTable();
		if (confirm("Are you sure you want to delete this sun protection policy?")) {
			$.ajax({
				url: "/ajax/accreditation/sun-protection-policy/delete",
				type : "POST",
				contentType : 'application/json',
				data : JSON.stringify({r: $elem.data('sun-protection-policy-id'), w: $elem.data('workplace-id'), token: $elem.data('token')})
			}).done(function() {
				table.fnDraw(true);
			}).fail(function() {
				alert("Sorry, the sun protection policy could not be deleted.")
			});			
		}
	});
	
	$('.control-measures').on('click', 'label', function(e) {
		var $label = $(e.currentTarget);
		var $input = $('#'+$label.attr('for'));
		var labels = $label.closest('tr').find('label');
		var currentLabels = $('.control-measures-label[for="'+$label.attr('for')+'"]');
		
		$.each(labels, function(i, label) {
			$(label).removeClass('active');
		});
		
		if ($input.prop('checked') == false) {
			currentLabels.each(function() {
				$(this).addClass('active');
			});
		}
		$input.prop('checked', true);
		
		$input.parents('tr').removeClass('invalid');
		
	})
	
	if ($('#payment-form').length) {
		var $form = $('#payment-form');
		const stripe = Stripe($form.data('public-key'));
		const options = {
			clientSecret: $form.data('secret'),
			// Fully customizable with appearance API.
			appearance: {/*...*/},
		};

		// Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 3
		const elements = stripe.elements(options);

		// Create and mount the Payment Element
		const paymentElement = elements.create('payment');
		paymentElement.mount('#payment-element');

		$form.submit(function(event) {
			event.preventDefault();
			var $subButton = $('#payment-form-submit');
			var subText = $subButton.text();
			$('#stripe-error').hide();
			$subButton.attr('type','button').html('<span class="icon-sync2 spin"></span>')
			stripe.confirmPayment({
				//`Elements` instance that was used to create the Payment Element
				elements,
				confirmParams: {
					return_url: document.location.origin+'/secure/workplace/status',
				},
			}).then(function(result) {
				if (result.error) {
					$subButton.attr('type','submit').html(subText)
					$('#stripe-error').text(result.error.message).show();
				}

			})
		});
	}
	
	
	
	$('.resend-jwt').on('click', function(e) { 
		
		var $clicked = $(e.currentTarget);
		var $links = $('.resend-jwt');
		
		$.ajax({
			url: "/ajax/user/resend-verification-email",
			type : "POST",
			contentType : 'application/json',
			data : JSON.stringify({token: $clicked.data('token')})
		}).done(function(response) {
			if(response.status == 'sent') {
				$links.parent().text('Success! New email validation code sent. Check inbox & follow instructions to verify.');
			} else {
				$links.each(function() {
					var $topBar = $(this).closest('.validate-top-bar');
					if ($topBar.length) {
						$topBar.slideUp("normal", function() { 
							$links.closest('.validate-top-bar').remove();
						});
					} else {
						$links.remove();
					}
				});
				$('body').removeClass('unvalidated');	
				setHeaderTrigger($('header').outerHeight());
			}
		}).fail(function() {
			alert("Sorry, we couldn't send you a new code. Please try again later.")
		});			
	});
	
	setHeaderTrigger($('header').outerHeight());
	
	headerLogoScroll();
	registerButtonScroll();
	
	$(window).on('scroll', function() {
		if (!$('.is-reveal-open').length) {
			headerLogoScroll();
			registerButtonScroll();
		}
	})
	
	$('.next-section-button').on('click', function(e) {
		if ($('.hero-section').find($(e.currentTarget)).length == 1) {
			$([document.documentElement, document.body]).animate({
				scrollTop: ($('.hero-section').next().offset().top - $('header').outerHeight())
			}, 750);
		} else {
			$([document.documentElement, document.body]).animate({
				scrollTop: ($(e.currentTarget).next('section').offset().top - $('header').outerHeight())
			}, 750);
		}
	})
	
	$('.view-image-modal').click(function(e) {
		var $modal = $('<div id="image-modal" class="reveal grid-container white-bg" data-reveal><div class="grid-x align-middle" style="height: 100%;"><img class="cell" src="'+$(e.currentTarget).data('img-src')+'"/><button class="close-button" aria-label="Close alert" type="button" data-close><span aria-hidden="true">&times;</span>  </button></div></div>');
		$('body').append($modal);
		$modal.foundation();
		$modal.foundation('open');
		$modal.on('closed.zf.reveal', function() {
			$modal.foundation('_destroy').remove();
		});
	});
	
$('.play-iframe-video').each(function(index, element) {
    var videoUrl = $(element).data('video-url');

    var options = {
      url: videoUrl
    };

    // Find the closest ancestor element with the video ID
    var videoContainer = $(element).parent().find('[id^="vimeo-video"]'); // Selects elements with IDs starting with "vimeo-video"

    // Ensure the video container is found before proceeding
    if (videoContainer.length > 0) {
      var playerId = videoContainer.attr('id');

      var player = new Vimeo.Player(playerId, options);

      $(element).on('click', function(e) {
        player.play().then(function() {
          $(e.currentTarget).hide();
        }).catch(function(error) {
          switch (error.name) {
            case 'PasswordError':
              console.log("video is password protected");
              break;
            case 'PrivacyError':
              console.log("video is private");
              break;
            default:
              console.log("Error: "+error.name+" - "+error.message);
              break;
          }
        });
      });
    } else {
      console.error("Unable to find video container element for", videoUrl);
    }
  });
	
	
	
	// Simplified version of launch-modal-video function from training
	$('.play-modal-video').click(function(e) {
		
		var $modalButton = ($(e.currentTarget));
		
		console.log( $modalButton.data('video-url'));

		var options = {
			url: $modalButton.data('video-url'),
			playsinline: true
		};
		
		var player = new Vimeo.Player('vimeo-video', options);
				
		var $modal = $('#video-modal');
		
		$modal.foundation('open');
		
		player.play().then(function() {			
			$modal.closest('.reveal-overlay').addClass('light-grey-bg');
		}).catch(function(error) {
			switch (error.name) {
				case 'PasswordError':
					console.log("video is password protected");
				break;
				case 'PrivacyError':
					console.log("video is private");
				break;
				default:
					console.log("Error: "+error.name+" - "+error.message);
				break;
			}
		});
		
		
		$modal.on('closed.zf.reveal', function() {
			player.pause();
		});
		
	});
	
	
	// textarea min/max lengths
	$(document).on('input propertychange','textarea.field-input', function() {
		var $p = $(this).siblings('.chars-remaining');
		var len = $(this).val().length;
		if ($(this).data('min-length') && $(this).data('max-length')) {
			if (len < $(this).data('min-length')) {
				$p.text((parseInt($(this).data('min-length')) - len)+' characters required');
			} else {
				if (len > $(this).data('max-length')) {
					this.value = this.value.substring(0, $(this).data('max-length'));
				}
				len = $(this).val().length
				$p.text((parseInt($(this).data('max-length')) - len)+' characters remaining');
			}
		} else if ($(this).data('min-length')) {
			$p.text((parseInt($(this).data('min-length')) - len)+' characters required');
		} else if ($(this).data('max-length')) {
			if (len > $(this).data('max-length')) {
				this.value = this.value.substring(0, $(this).data('max-length'));
			}
			len = $(this).val().length
			$p.text((parseInt($(this).data('max-length')) - len)+' characters remaining');		 
		}
	})
	
	$('.show-password').on('click', function (e) {
		var $input = $(e.currentTarget).parent().prev();
		if ($input.attr('type') == 'password') {
			$input.attr('type', 'text')
		} else {
			$input.attr('type','password')
		}
	});
	
	$(document).on('click', '.cookie-process', function(e) {
		$.ajax({
			type        : 'POST',
			url         : '/ajax/set-cookie-consent',
			data        : {
											'consent'	 : ($(e.currentTarget).hasClass('accept')?1:0)
										},
			dataType    : 'json',
			success: function(data){
				$('.cookie-consent-overlay').fadeOut(500,function() {
					$(this).remove();
				})
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				$('.cookie-consent-overlay').fadeOut(500,function() {
					$(this).remove();
				})
			}
		});
	});
	
	$('#show-cookies-banner').on('click', function(e) {		
		$.ajax({
			type : 'GET',
			url : '/ajax/get-cookies-banner',
			success: function(data) {
				var $elem = $(data.html);
				$(e.currentTarget).before($elem);
				$elem.show();
			}
		})
	});
	
	$('.update-acceptance').on('click', function(e) {
		var numInvites = $('.invitation').length;
		var $invite = $(e.currentTarget).closest('.invitation');
		var $button = $(e.currentTarget);
		var workplaceId = $invite.data('workplace-id');
		var data = {
			workplaceId	 : workplaceId,
			acceptance : $button.val()
		};
		
		$.ajax({
			type : 'POST',
			url : '/ajax/workplace/update-acceptance',
			data : JSON.stringify(data),
			dataType : 'json',
			success: function(response){
				if ((numInvites - 1) == 0) {
					window.location.href = response.redirectUrl;
				} else {
					$invite.remove();
				}
			},
			error: function() {
				alert("Sorry, something went wrong. Please try again later.")
			}
		});
	})
	
	$(document).on('click', '.revoke', function(e) {
		var table = $('#table_workplace-users').dataTable();	
		if (confirm("Are you sure you want to revoke access for this company admin?")) {
			revokeUser($(e.currentTarget), table);	
		}	
	});
	
	
	$('#cancel-pending-email').on('click', function(e) {		
		$.ajax({
			url: "/ajax/user/cancel-pending-email",
			type : "POST",
			contentType : 'application/json',
			data : JSON.stringify({token: $(e.currentTarget).data('token')})
		}).done(function(response) {
			location.reload();
		}).fail(function() {
			alert("Sorry, we couldn't cancel. Please try again later.")
		});			
	});
	

		
	$(document).on('click','.launch-accreditation-application-modal', function(e) {
		if ($('#accreditation-application-modal').length) {
			$('#accreditation-application-modal').foundation('open');
		} else {
			var $modal = $('<div id="accreditation-application-modal" class="reveal large" data-reveal data-close-on-click="false" data-close-on-esc="false"></div>');
			$('body').append($modal);
			$modal.foundation();
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/modal-accreditation-application',
				contentType : 'application/json'
			}).done(function(response){
				var saveExit = false;
				$modal.html(response.modalHtml).foundation('open');
				var $form = $modal.find('form');
				var $errors = $form.find('.form-errors');
				var $content = $form.find('.modal-content');
				// make sure any hidden fields are not set as required
				$form.find('.application-question.hide').find('.field-textarea, .field-radio').prop('required', false);
				$modal.on('click', '.save-exit', function(e) {
					// Create trigger for save and exit, append to form
					$form.append('<input name="saveExitTrigger" type="hidden" value="1"></input>')
					$form.submit();
				});
				$modal.on('submit','#accreditation-application-form', function(e) {
					e.preventDefault();
					if ($form.find('input[name="saveExitTrigger"]').length) { 
						saveExit = true;
					}
					$errors.empty().hide();
					
					var data = $form.serializeObject();
					
					if (saveExit) {
						
						var inputs = $form.find('input');
						
						// Loop through inputs setting as not mandatory if name attribute doesn't exist in the serialized form data
						$.each(inputs, function() {
							if ($.inArray($(this).attr('name'), data) == -1) {
								$(this).prop('required', false);
							}
						})
					}
					if ($form.find('input[name="saveExitTrigger"]').length) {
						$('input[name="saveExitTrigger"]').remove();
					}
					$.ajax({
						method: "POST",
						url: '/ajax/accreditation/modal-accreditation-application',
						contentType : 'application/json',
						data: JSON.stringify(data)
					}).done(function(response){
						if (response.complete) {
							$modal.html(response.modalHtml);				
						} else {							
							if (saveExit) {
								$modal.foundation('_destroy').remove();
							} else {
								$content.html(response.html);
								$form.find('.progress-meter').width(response.pc+'%');
								// make sure any hidden fields are not set as required
								console.log("setting as not mandatory 2", $form.find('.application-question.hide').find('.field-textarea, .field-radio'));
								$form.find('.application-question.hide').find('.field-textarea, .field-radio').prop('required', false);
							}
						}
						if (response.buttonText) {
							$(document).find('.launch-accreditation-application-modal').text(response.buttonText);
							if (response.complete == true) {
								$('.download-application-form-wrapper').hide();
							}
						}
						$('html, body, .reveal-overlay, .reveal').animate({
							scrollTop: 0
						}, 500);
					}).fail(function(jqXHR, textStatus, errorThrown) {
						$errors.html('Sorry, we couldn&rsquo;t save your answer. Please reload the page and try again or contact support').show();
					});
				});
				// change handler to activate/deactivate subsequent questions when a radio button is changed
				$modal.on('change', '.field-radio, .field-multicheckbox', function(e) {
					var $input = $(e.currentTarget);
					var noneOfAboveQuestion = false;
					var noneOfAboveAnswer = false;
					var deactivatedQuestionIds = [];
					var activatedQuestionIds = [];
					var $activatingQuestion = $input.closest('.application-question');
					// check all options in the question to see if any are None of the above
					$activatingQuestion.find('input').each(function(i,q) {
						var optionText = $(q).next('.field-label-text').text();
						if (optionText == 'None of the above' || optionText == 'This is not applicable for us') {
							noneOfAboveQuestion = true;
						}
					});
					
					var optionText = $input.next('.field-label-text').text();
					if ($input.prop('checked') && (optionText == 'None of the above' || optionText == 'This is not applicable for us')) {
						noneOfAboveAnswer = true;
					}
					
					if (noneOfAboveQuestion) {
						// if this question has a 'none of the above' option, make sure the mutually exclusive ones are unchecked
						$activatingQuestion.find('input').each(function(i,q) {
							var optionText = $(q).next('.field-label-text').text();
							if ((noneOfAboveAnswer && optionText != 'None of the above' && optionText != 'This is not applicable for us') ||  (!noneOfAboveAnswer && (optionText == 'None of the above' || optionText == 'This is not applicable for us'))) {
								$(q).prop('checked', false);
							}
						});
					}
					$activatingQuestion.find('input').each(function(i,q) {
						if ($(q).data('activates-question-id') !== undefined) {
							var activatedQuestionId = $(q).data('activates-question-id');
							if (!$(q).prop('checked') && $.inArray(activatedQuestionId,deactivatedQuestionIds) === -1) {
								// if this checkbox is not checked and the id is not yet in the array of questions to be deactivated, add it to the array
								deactivatedQuestionIds.push(activatedQuestionId);
							}
							if ($(q).prop('checked') && $.inArray(activatedQuestionId,activatedQuestionIds) === -1) {
								// if this checkbox is not checked and the id is not yet in the array of questions to be deactivated, add it to the array
								activatedQuestionIds.push(activatedQuestionId);
							}
						}
					});
					// cycle through our deactivating questions, adding any that aren't in the activating list to a new array of questions to deactivate
					var questionsToDeactivate = [];
					$.each(deactivatedQuestionIds, function(k,qId) {
						if ($.inArray(qId,activatedQuestionIds) === -1) {
							questionsToDeactivate.push(qId);
						}
					});
					// deactivate any questions in the questionsToDeactivate array
					$.each(questionsToDeactivate, function(k,qId) {
						var $deactivatedQuestion = $('.question-'+qId);
						$deactivatedQuestion.addClass('hide').next('.application-question-hr').addClass('hide');
						$deactivatedQuestion.find('.field-radio, .field-textarea').prop('required',false);
						// deselect any checked radio or multicheckbox inputs and trigger their change to propagate any chained inputs
						$deactivatedQuestion.find('.field-radio, .field-multicheckbox').prop('checked',false).trigger('change');
					});
					// activate any questions the activatedQuestionIds array
					$.each(activatedQuestionIds, function(k,qId) {
						var $activatedQuestion = $('.question-'+qId);
						$activatedQuestion.removeClass('hide').next().removeClass('hide');
					});
				});

				$modal.on('click', '.prev', function(e) {
					$errors.empty().hide();
					var data = {
						prevC: $(e.currentTarget).data('c')
					};
					$.ajax({
						method: "POST",
						url: '/ajax/accreditation/modal-accreditation-application',
						contentType : 'application/json',
						data: JSON.stringify(data)
					}).done(function(response){
						$content.html(response.html);
						$form.find('.progress-meter').width(response.pc+'%');
						// make sure any hidden fields are not set as required
						console.log("setting as not mandatory 3", $form.find('.application-question.hide').find('.field-textarea, .field-radio'));
						$form.find('.application-question.hide').find('.field-textarea, .field-radio').prop('required', false);
						$('html, body, .reveal-overlay, .reveal').animate({
							scrollTop: 0
						}, 500);
					}).fail(function(jqXHR, textStatus, errorThrown) {
						$errors.html('Sorry, we couldn&rsquo;t save your answer. Please reload the page and try again or contact support').show();
					});
				});
			}).fail(function(jqXHR, textStatus, errorThrown) {
				$modal.html('<div class="grid-x grid-padding-x grid-padding-y"><div class="cell"><p>Sorry, we couldn&rsquo;t load the form. Please try later</p><a class="button primary" onClick="window.location.reload();">Try Again</a></div></div>').foundation('open');
			});
		}
	});
	
	$(".prevent-multi").submit(function() {
		// submit more than once return false
		$(this).submit(function() {
				return false;
		});
		// submit once return true
		// change label or value submit
		$("button[type='submit']", this).html('<span class="icon-sync2 spin"></span>');
		return true;
	});

		
	$('.launch-delete-workplace-modal').on('click', function(e) {
		var workplaceId = $(e.currentTarget).data('workplace-id');
		if ($('#delete-workplace-modal').length) {
			$('#delete-workplace-modal').foundation('open');
		} else {
			var $modal = $('<div id="delete-workplace-modal" class="reveal" data-reveal></div>');
			$('body').append($modal);
			$modal.foundation();
			$.ajax({
				method: "POST",
				url: '/ajax/workplace/modal-delete',
				contentType : 'application/json',
				data: JSON.stringify({ 
					w: workplaceId,
					action: 'GET'
				})
			}).done(function(response){
				$modal.html(response.html).foundation('open');
				var $form = $modal.find('form');
				var $errors = $form.find('.form-errors');
				var $content = $form.find('.modal-content');
				$modal.on('submit','#delete-workplace-form', function(e) {
					e.preventDefault();
					$errors.empty().hide();
					var data = $form.serializeObject();
					data.w = workplaceId;
					data.action = 'DELETE';
					$.ajax({
						method: "POST",
						url: '/ajax/workplace/modal-delete',
						contentType : 'application/json',
						data: JSON.stringify(data)
					}).done(function(response){
						if (response.success == true) {
							location.reload();
						} else {
							$errors.html(response.error).show();
						}
						$('html, body, .reveal-overlay, .reveal').animate({
							scrollTop: 0
						}, 500);
					}).fail(function(jqXHR, textStatus, errorThrown) {
						$errors.html('Sorry, we couldn&rsquo;t delete your workplace. Please reload the page and try again or contact support').show();
					});
				});
			}).fail(function(jqXHR, textStatus, errorThrown) {
				$modal.html('<div class="grid-x grid-padding-x grid-padding-y"><div class="cell"><p>Sorry, we couldn&rsquo;t load the form. Please try later</p><a class="button primary" onClick="window.location.reload();">Try Again</a></div></div>').foundation('open');
			});
		}
	});
			
	if ($('.licences-slider').length) {
		updateLicencesPrices($('.slider-handle'));
	}
	
	$('.licences-slider').on('moved.zf.slider', function(e) {
		updateLicencesPrices($('.slider-handle'), e);
	});
	
	$('.infographic-step').on('click', function(e) {
		if ($(e.currentTarget).hasClass('disabled')) {
//			alert('Actions required before you can continue with your accreditation.');
			//$('.infographic-disabled')[0].scrollIntoView();
			$([document.documentElement, document.body]).animate({
				scrollTop: ($('.infographic-disabled').offset().top - $('header').outerHeight() - 20)
			}, 750);
		}
	});
	
	
	
	$('select[name="country"]').on('change', function(e) {
		console.log('hello world');
		if (e.currentTarget.value === '2') {
			showFieldHolder('county', true);
		} else {
			hideFieldHolder('county');
		}
	})
	
	
	
	// show uv regions
	$('#uv-region').click(function() {
		$('.uv-region-options').slideDown('fast');
	});
	
	// select a new uv region
	$('.uv-name a').click(function() {
		var newRegionName = $(this).text()
		$.post("/ajax/uv-forecast", {q:$(this).data('uv-id')})
		.done(function(data) {
			$(".uv-triangles").html(data);
			$("#region-name").html(newRegionName);
			$(".uv-region-options").slideUp('fast');
		});
	});

	// hide uv region dd box on click off
	$(document).click(function(event) {	
		if(!$(event.target).closest('#uv-region').length) {
			$('.uv-region-options').fadeOut();
		}       
	});
	// END hide uv region dd box on click off	
	
	$('.toggle-instructions').on('click', function(e) {
		var $button = $(e.currentTarget);
		$button.toggleClass('active');
		
		var $instructions = $button.nextAll('.instructions').filter(':first');
		$instructions.fadeToggle();
	});	
	
});

// resize functions, throttled to run a max of once every 250ms 
$(window).on('resize', Foundation.util.throttle(function(e){
  setExcerptHeights();
	$('body.training-page .page').height($(window).height()-$('header').outerHeight());
}, 250));

var form = $('form')   //your form element
scrollToInvalid(form);

function scrollToInvalid(form) {
	var header = $('header');

	// listen for `invalid` events on all form inputs
	form.find(':input').on('invalid', function(event) {
		var input = $(this)
		// the first invalid element in the form
		var first = form.find(':invalid:not(fieldset)').first()
		// only handle if this is the first invalid input
		if (input[0] === first[0]) {
				// height of the nav bar plus some padding
				var headerHeight = header.height() + 150
				console.log("headerHeight",headerHeight);
				// the position to scroll to (accounting for the navbar)
				var elementOffset = input.offset().top - headerHeight
				console.log("elementOffset",elementOffset);

				// the current scroll position (accounting for the navbar)
				var pageOffset = window.pageYOffset - headerHeight
				console.log("pageOffset",pageOffset);
				console.log("window.innerHeight",window.innerHeight);
				console.log("pageOffset + window.innerHeight",pageOffset + window.innerHeight);

				// don't scroll if the element is already in view
				if (elementOffset > pageOffset && elementOffset < pageOffset + window.innerHeight) {
					console.log("elementOffset > pageOffset && elementOffset < pageOffset + window.innerHeight");
						return true
				}
				console.log("scrolling");
				// note: avoid using animate, as it prevents the validation message displaying correctly
				$('html,body').scrollTop(elementOffset)
		}
	});
	
	if ($('body.analytics').length) {
		analyticsCharts();
	}
	
}


/**************
*
* Functions
*
***************/

function keepAlive() {
	$.ajax({
		url: "/ajax/keep-alive",
		type : "GET",
		contentType : 'application/json',
	}).done(function() {
		console.log("Session kept alive")
	}).fail(function() {
		//$('.reveal-overlay').remove();
		var $modal = $('<div class="reveal" data-reveal data-close-on-click="false" data-close-on-esc="false"><div class="grid-x grid-padding-x grid-padding-y"><div class="cell"><p>Your session has expired, please reload the page and re-enrol before continuing with the training</p><a class="button primary" onClick="window.location.reload();">Reload</a></div></div></div>');
		$('body').append($modal);
		$modal.foundation();
		$modal.foundation('open')
	});
}

function setExcerptHeights() {
	var excerpts = $('.excerpt');
	excerpts.css('height','');
  // Get an array of all excerpt heights
  var elementHeights = excerpts.map(function() {
    return $(this).height();
  }).get();
  // Math.max takes a variable number of arguments
  // `apply` is equivalent to passing each height as an argument
  var maxHeight = Math.max.apply(null, elementHeights);

  // Set each height to the max height
  excerpts.height(maxHeight);
}

function hideFieldHolder(fieldId) {
	$('#'+fieldId).prop('required',false);
	$('#'+fieldId).closest('.cell').slideUp('fast');
	if ($('#'+fieldId).siblings('label').length) {
		$('#'+fieldId).prevAll('label').children().remove('span.mandatory');
	} else {
		$('#'+fieldId).closest('.input-group').prev('label').children().remove('span.mandatory');
		//$('#'+fieldId).closest('label').children().remove('span.mandatory');
	}
}

function showFieldHolder(fieldId, mandatory) {
	if (mandatory) {
		$('#'+fieldId).prop('required',true);
		if ($('#'+fieldId).siblings('label').length) {
			$('#'+fieldId).prev('label').prepend('<span class="mandatory">*</span>');
		} else {
			$('#'+fieldId).closest('.input-group').prev('label').prepend('<span class="mandatory">*</span>');
			//$('#'+fieldId).closest('label').prepend('<span class="mandatory">*</span>');
		}
	}
	$('#'+fieldId).closest('.cell').removeClass('hide');
	$('#'+fieldId).closest('.cell').slideDown('fast');
}
function setFieldLabel(fieldId,labelText) {
	$('#'+fieldId).prevAll('label').text(labelText);
}

// function to make form values to json format
$.fn.serializeObject = function(){
	var o = {};
	var a = this.serializeArray();
	$.each(a, function() {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};

/**
* setHeaderTrigger
*
* sets the height for the header trigger
*/
function setHeaderTrigger(height) {
	$('.header-trigger').height(height);
}

/**
* headerLogoScroll
*
* resize logo in header depending on scroll position
*/
function headerLogoScroll() {
	if (!$('body').hasClass('training-page')) {
		var scrollPos = $(this).scrollTop();
		var headSize = $('header').outerHeight();
		if (scrollPos >= headSize) {
			$('header').find('.shield-logo').addClass('small');
		} else {
			$('header').find('.shield-logo').removeClass('small');
		}
	}
}

function registerButtonScroll() {	
	var $headerButton = $('header').find('.register-button');
	if ($headerButton.length) {
		var scrollPos = $(this).scrollTop();
		if (scrollPos >= ($('.hero-section').scrollTop() + $('.hero-section').outerHeight())) {
			$headerButton.fadeIn(500);
		} else {
			$headerButton.fadeOut(500);
		}
	}
}

/**
* revokeUser
*/
function revokeUser(button, table) {
	var workplaceId = button.data('workplace-id');
	var userId = button.data('user-id');
	
	var data = {
		w : workplaceId,
		userId : userId
	}
	
	$.ajax({
		type : 'POST',
		url : '/ajax/workplace/revoke',
		data : JSON.stringify(data),
		dataType : 'json',
		success: function(response){
			table.fnDraw(true);
		},
		error: function() {
			alert("Sorry, something went wrong. Please try again later.")
		}
	});
}

function updateLicencesPrices($slider, e) {	
	var licences = $('#num-licences').val();
	
	// Retrieve pricing information
	var defaultPrice = $slider.data('default-price');
	var workplacePricing = $slider.data('pricing').slice();
	// Revese array of prices to loop through
	workplacePricing.reverse();
	
	var fullPrice = (licences * defaultPrice).toFixed(2);
	var pricePerLicence = 0;
	
	$.each(workplacePricing, function(key,value) {
		// If number of licences selected is greater than or equal to number of licences in the pricing, discount price found
		if (licences >= parseInt(value.minLicences)) {
			pricePerLicence = parseFloat(value.price);
			return false;
		}
	}); 

	var discountPrice = 0;
	if (pricePerLicence != defaultPrice) {
		discountPrice = (pricePerLicence * licences).toFixed(2);
	}
	
	$('.full-price').find('span').text(fullPrice);
	$('.discount-price').find('span').text(discountPrice);
	
	if (discountPrice > 0) {
		$('.discount-price').show();
		$('.full-price').addClass('discounted');
	} else {
		$('.discount-price').hide();
		$('.full-price').removeClass('discounted');
	}
}

function analyticsCharts() {
	
	var $chartElements = $('.analytics-chart');
	var $mutliCharts = $('.analytics-multichart');
	
	var workplaceId = $('body').data('workplace-id');
	
	google.charts.load('current', {packages: ['corechart', 'bar']});
	
	$.each($chartElements, function(i, chartElement) {

		var ajaxFile = '/ajax/accreditation/analytics/'+$(chartElement).data('ajax');
		
		var data = {
			w	 : workplaceId,
		};
		
		function getChartData(callback) {
			$.ajax({
				type : 'POST',
				url : ajaxFile,
				data : JSON.stringify(data),
				dataType : 'json',
				success: function(response){
					callback(response);
				},
				error: function() {
					alert("Sorry, something went wrong. Please try again later.")
				}
			});

		}
		
		getChartData(function(response) {
			
			// Check for chartData
			if (!response.chartData) {
				$(chartElement).css('min-height', 0);
				$(chartElement).html('<p class="margin-top-1 margin-bottom-1 text-center"><span class="warning">No data to display.</span></p>');
				return false;
			}
			
			var tooltipElement = $('<div class="tooltip" style="display:none;"></div>').appendTo('body');

			function attachYLabelTooltips() {
				// Check if ylabel tooltips should be included
				if (!response.yLabelTooltips) {
					return;
				}
				$(chartElement).find('g text[text-anchor="end"]').off('mouseover').off('mouseout');

				var yLabels = chartElement.querySelectorAll('g text[text-anchor="end"]');
				$.each(yLabels, function(i, yLabel) {
					var tooltipHtml = response.chartData.rows[i].c[2].v;
				
					$(yLabel).on('mouseover', function(event) {
            var tooltipHeight = tooltipElement.outerHeight();
            var cursorX = event.pageX; 
            var cursorY = event.pageY; 
						
            var tooltipLeft = cursorX + 10; 
            var tooltipTop = cursorY - (tooltipHeight / 2);

            // Update tooltip content and position
            tooltipElement.html(tooltipHtml).css({ left: tooltipLeft, top: tooltipTop }).show();
						}).on('mouseout', function() {
							tooltipElement.hide();
						});
					
					// Add chevron element next to the ylabel
					$(yLabel).css('cursor', 'pointer');
					$(yLabel).append('&#9662;');
				});
			}

			google.charts.setOnLoadCallback(draw);

			function draw() {
				var data = new google.visualization.DataTable(
					response.chartData
				);

				var chart;
				switch (response.chartType) {
					case 'BarChart':
						chart = new google.visualization.BarChart(chartElement);
						break;
					case 'ColumnChart':
						chart = new google.visualization.ColumnChart(chartElement);
						break;
				}
				chart.draw(data, response.options);

				attachYLabelTooltips(chartElement, data, response);

				$(window).on('resize', Foundation.util.throttle(function() {
					chart.clearChart();
					chart.draw(data, response.options);
					attachYLabelTooltips(chartElement, data, response);
				}, 300));
			}
			
			var $numEmployees = $(chartElement).parents('section').prev('section').find('.num-employees');
			
			$numEmployees.find('span').text(response.total);
			$numEmployees.show();
			
		});
		
	});
	
	$.each($mutliCharts, function(i, multiChart) {
    var ajaxFile = '/ajax/accreditation/analytics/' + $(multiChart).data('ajax');

    var data = {
			w: workplaceId,
    };

    var responseData; // Variable to store response data

    var getChartData = function(callback) {
			$.ajax({
				type: 'POST',
				url: ajaxFile,
				data: JSON.stringify(data),
				dataType: 'json',
				success: function(response) {
					responseData = response; // Store response data
					callback(response);
				},
				error: function() {
					alert("Sorry, something went wrong. Please try again later.")
				}	
			});
    };

		var draw = function(response) {
			
			// Check for chartData
			if (!response.chartData) {
				$(multiChart).removeClass('large-12');
				$(multiChart).addClass('large-8');
				$(multiChart).html('<div class="analytics-chart cell small-12 text-center" style="min-height:0;"><p class="margin-top-1 margin-bottom-1"><span class="warning">No data to display.</span></p></div>');
				return false;
			}
			
			// Clear existing chart divs
			$(multiChart).empty();

			// Iterate over each chartData object
			$.each(response.chartData, function(key, value) {
				
				// Create a div for the chart
				var chartId = 'chart-' + key;
				$('<div class="cell small-12 medium-6 large-3 analytics-multichart-item">').attr('id', chartId).appendTo(multiChart);

				// Prepare the data for Google Charts
				var data = new google.visualization.DataTable();
				$.each(value.cols, function(index, col) {
					data.addColumn(col);
				});

				$.each(value.rows, function(index, row) {
					data.addRow(row.c);
				});

				
				var chartElem = document.getElementById(chartId);
				
				// Draw the chart
				var chart = new google.visualization.PieChart(chartElem);
				chart.draw(data, value.options);
				
				var $questionTextElem = $('<div data-equalizer-watch="grey" class="question-text">'+value.questionText+'</div>');
				
				$(chartElem).prepend($questionTextElem);
		
				Foundation.reInit('equalizer');
				
				$(window).on('resize', Foundation.util.throttle(function() {
					chart.clearChart();
					chart.draw(data, value.options);				
					// Due to chart being on chartElem clearing chart removes question text. prepend again
					$(chartElem).prepend($questionTextElem);
				}, 300));
			});
					
			var $numEmployees = $(multiChart).parents('section').prev('section').find('.num-employees');
			
			$numEmployees.find('span').text(response.total);
			$numEmployees.show();
		};

		google.charts.setOnLoadCallback(function() {
			getChartData(draw);
		});
		
	});
	
	if ($('.analytics-lo').length) {
    var ajaxFile = '/ajax/accreditation/analytics/' + $('.analytics-lo').data('ajax');

    var data = {
			w: workplaceId,
    };

    var responseData; // Variable to store response data

    var getChartData = function(callback) {
			$.ajax({
				type: 'POST',
				url: ajaxFile,
				data: JSON.stringify(data),
				dataType: 'json',
				success: function(response) {
					responseData = response; // Store response data
					callback(response);
				},
				error: function() {
					alert("Sorry, something went wrong. Please try again later.")
				}	
			});
    };

		var draw = function(response) {
			
			var $wrapper = $('.analytics-lo');
			
			// Check for chartData
			if (!response.chartData) {
				$wrapper.removeClass('large-12');
				$wrapper.addClass('large-8');
				$wrapper.html('<div class="analytics-chart cell small-12 text-center" style="min-height:0;"><p class="margin-top-1 margin-bottom-1"><span class="warning">No data to display.</span></p></div>');
				return false;
			}
			
			// Clear existing chart divs
			$wrapper.empty();

			// Iterate over each chartData object
			$.each(response.chartData, function(key, value) {

				// Create a div for the chart
				var chartId = 'chart-' + key;

				// Create analytics-multichart-item div
				var multichartItem = $('<div class="cell small-12 large-6 analytics-multichart-item grid-x grid-padding-x">').attr('id', chartId).appendTo('.analytics-lo');

				// Create entry chart div
				var entryChartId = chartId + '-entry';
				$('<div class="chart-container cell small-6">').attr('id', entryChartId).appendTo(multichartItem);

				// Create exit chart div
				var exitChartId = chartId + '-exit';
				$('<div class="chart-container cell small-6">').attr('id', exitChartId).appendTo(multichartItem);

				// Prepare the data for Google Charts for entry
				var entryData = new google.visualization.DataTable();
				$.each(value.entry.cols, function(index, col) {
					entryData.addColumn(col);
				});

				$.each(value.entry.rows, function(index, row) {
					entryData.addRow(row.c);
				});
				
				// Do not display the legends
				value.entry.options.legend = 'none';	
				value.exit.options.legend = 'none';		

				// Draw the entry chart
				var entryChartElem = document.getElementById(entryChartId);
				var entryChart = new google.visualization.PieChart(entryChartElem);	
				entryChart.draw(entryData, value.entry.options);
				
				// Prepare the data for Google Charts for exit
				var exitData = new google.visualization.DataTable();
				$.each(value.exit.cols, function(index, col) {
					exitData.addColumn(col);
				});

				$.each(value.exit.rows, function(index, row) {
					exitData.addRow(row.c);
				});

				// Draw the exit chart
				var exitChartElem = document.getElementById(exitChartId);
				var exitChart = new google.visualization.PieChart(exitChartElem);				
				exitChart.draw(exitData, value.exit.options);
				
				// Custom legends
				
				var legendData = {};

				$.each(value.entry.rows, function(index, row) {
					var option = row.c[0].v; // Get the option label
					var colorIndex = index % value.entry.options.colors.length; // Get the color index
					var color = value.entry.options.colors[colorIndex]; // Get the color
					// Check if the option already exists in legendData
					if (!legendData[option]) {
						// If it doesn't exist, add the color to the legendData
						legendData[option] = color;
					}
				});
						
				var legendHTML = '<ul class="legend">';
				
				for (var category in legendData) {
					if (legendData.hasOwnProperty(category)) {
						
						var color = legendData[category];
						// Generate HTML for legend item
						legendHTML += '<li><span class="legend-color" style="background-color: ' + color + '"></span>' + category + '</li>';
					}
				}							
				legendHTML += '</ul>';
				
				// Prepend legend
				$(multichartItem).prepend('<div class="cell small-12 text-left margin-top-1 grid-x grid-margin-x"><div class="cell small-8 large-7">'+legendHTML+'</div><div class="cell small-4 large-5 text-right"><p class="bold"><span class="success">'+value.improvement+'</span></p></div></div>');
				
				// Prepend question text
				$(multichartItem).prepend('<div data-equalizer-watch="grey" class="question-text cell small-12">'+value.questionText+'</div>');
				
				// Append title and descriptions
				$(multichartItem).append('<div class="cell small-6 chart-description text-center"><h3>PRE-TRAINING ASSESSMENT</h3><p>'+value.entry.desc+'</p></div><div class="cell small-6 chart-description text-center"><h3>POST-TRAINING ASSESSMENT</h3><p>'+value.exit.desc+'</p></div>');
		
				Foundation.reInit('equalizer');
				
				// Clear and re-draw the exit and entry charts on resize				
				$(window).on('resize', Foundation.util.throttle(function() {
					exitChart.clearChart();
					exitChart.draw(exitData, value.exit.options);
					entryChart.clearChart();
					entryChart.draw(entryData, value.entry.options);
				}, 300));				
			});			
					
			var $numEmployees = $wrapper.parents('section').prev('section').find('.num-employees');
			
			$numEmployees.find('span').text(response.total);
			$numEmployees.show();
			
		};

		google.charts.setOnLoadCallback(function() {
			getChartData(draw);
		});
		
	}

}